"use strict";

exports.__esModule = true;
var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

exports.default = mapValues;


//////////////////
// WEBPACK FOOTER
// ./~/recompose/utils/mapValues.js
// module id = 1785
// module chunks = 0